import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class MetricsDetailsController extends Controller {
	override queryParams = ['state'];

	@tracked state: string | null = null;
}
